export function isAdmin(role) {
  return role === "admin" ? true : false;
}
